// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"5414fd05","618":"2879ba1e","704":"a4173acc","763":"4bcdcc88","766":"77ff5835","938":"d5aa8246"}[chunkId] + ".chunk.css";
};